<template>
  <b-card>
    <b-form>
      <b-row>
        <b-col cols="12">
          <div class="d-flex align-items-center mb-2">
            <feather-icon icon="MailIcon" size="18" />
            <h4 class="mb-0 ml-75">
              {{ $t('SMTP Mail Sender Informations') }}
            </h4>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="d-flex align-items-center mb-2">
            <h6 class="mb-0">
              {{ $t('Type') }} : SMTP
            </h6>
          </div>
        </b-col>

        <b-col class="mt-1" md="6">
          <b-form-group :label="$t('Host')" label-for="smtp_host">
            <b-form-input id="smtp_host" class="form-control" v-model="localSettings.smtp_host"
              :placeholder="$t('SMTP Sender host')" />
          </b-form-group>
        </b-col>
        <b-col class="mt-1" md="6">
          <b-form-group :label="$t('Port')" label-for="smtp_port">
            <b-form-input id="smtp_port" v-model="localSettings.smtp_port" :placeholder="$t('SMTP Sender Port')" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="$t('Use Secure Connection')" label-for="isSecured">
            <div class="demo-inline-spacing mb-1">
              <b-form-radio v-model="localSettings.isSecured" name="isSecured" v-bind:value="false">
                {{ $t('Unsecured') }}
              </b-form-radio>
              <b-form-radio v-model="localSettings.isSecured" name="isSecured" v-bind:value="true">
                {{ $t('Secured') }}
              </b-form-radio>
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6"></b-col>

        <b-col md="6">
          <b-form-group :label="$t('SMTP Username')" label-for="smtp_username">
            <b-form-input id="smtp_username" v-model="localSettings.smtp_username"
              :placeholder="$t('SMTP Username')" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('SMTP Password')" label-for="smtp_password">
            <b-input-group>
              <b-row class="align-items-center">
                <b-col cols="10" class="pr-0">
                  <b-form-input id="smtp_password" v-model="localSettings.smtp_password"
                    :type="showPassword ? 'text' : 'password'" :placeholder="$t('SMTP Password')" class="w-100" />
                </b-col>
                <b-col cols="2" class="pl-0">
                  <b-button variant="outline-secondary" @click="showPassword = !showPassword"
                    class="password-toggle">
                    <feather-icon :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'" />
                  </b-button>
                </b-col>
              </b-row>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('From Mail')" label-for="account-google">
            <b-form-input id="account-google" v-model="localSettings.from_mail" :placeholder="$t('From Mail')" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="$t('From Title')" label-for="from_title">
            <b-form-input id="from_title" v-model="localSettings.from_title" :placeholder="$t('From Title')" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 mr-1"
            @click.prevent="sendInformation">
            {{ $t("Save Changes") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BCardText, BLink, BAvatar, BFormRadio, BFormCheckbox, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from "@axios";
import { ref } from "@vue/composition-api";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BAvatar,
    BCardText,
    BFormRadio,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  props: {
    smtpsettings: {
      type: Object,
      default: () => { },
    },
  },
  created() {
    this.localSettings = this.smtpsettings.data == null || JSON.parse(JSON.stringify(this.smtpsettings.data)).emailsettings == null ? {} : JSON.parse(JSON.parse(JSON.stringify(this.smtpsettings.data)).emailsettings);

  },
  data() {
    return {
      showPassword: false,
      localSettings: {},
      isLoading: false,
      isUpdated: false,
      clevePort: {
        numeral: true

      },

    }
  },
  methods: {
    sendInformation() {

      this.isLoading = true;
      axios({
        method: "put",
        url: `/admin/f/settings`,
        data: {
          info: "smtpsettings",
          file: null,
          content: this.localSettings,
        },
      })
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isLoading = false;
        });
      return;
    },
    resetForm() {
      this.localSettings = JSON.parse(JSON.stringify(this.smtpsettings))
    },
  },
}
</script>
